'use client';

import { c as _c } from "react/compiler-runtime";
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';
import { cn } from '@/lib/utils';
const Separator = t0 => {
  const $ = _c(15);
  let className;
  let props;
  let ref;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      ref,
      className,
      orientation: t1,
      decorative: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
    $[4] = t1;
    $[5] = t2;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const orientation = t1 === undefined ? "horizontal" : t1;
  const decorative = t2 === undefined ? true : t2;
  const t3 = orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]";
  let t4;
  if ($[6] !== className || $[7] !== t3) {
    t4 = cn("shrink-0 bg-border", t3, className);
    $[6] = className;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== decorative || $[10] !== orientation || $[11] !== props || $[12] !== ref || $[13] !== t4) {
    t5 = <SeparatorPrimitive.Root ref={ref} decorative={decorative} orientation={orientation} className={t4} {...props} />;
    $[9] = decorative;
    $[10] = orientation;
    $[11] = props;
    $[12] = ref;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
Separator.displayName = SeparatorPrimitive.Root.displayName;
export { Separator };